import { useTranslation } from 'react-i18next';
export const useCharacterTypes = () => {
    const { t } = useTranslation();
    return [
        { value: 'player', label: t('character.types.player') },
        { value: 'npc', label: t('character.types.npc') },
        { value: 'aberration', label: t('character.types.aberration') },
        { value: 'beast', label: t('character.types.beast') },
        { value: 'celestial', label: t('character.types.celestial') },
        { value: 'construct', label: t('character.types.construct') },
        { value: 'dragon', label: t('character.types.dragon') },
        { value: 'elemental', label: t('character.types.elemental') },
        { value: 'fey', label: t('character.types.fey') },
        { value: 'fiend', label: t('character.types.fiend') },
        { value: 'giant', label: t('character.types.giant') },
        { value: 'humanoid', label: t('character.types.humanoid') },
        { value: 'monstrosity', label: t('character.types.monstrosity') },
        { value: 'ooze', label: t('character.types.ooze') },
        { value: 'plant', label: t('character.types.plant') },
        { value: 'undead', label: t('character.types.undead') },
    ];
};
